/* CAPRIMAFFIA — TERRACE
   JS vanilla, sin dependencias. Scroll reveal, hero, ticker y slider de mundos. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     1. Scroll reveal — fade + translateY al entrar en viewport
     ---------------------------------------------------------------------- */
  var revealObserver = null;

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    return revealObserver;
  }

  function initReveal(root) {
    var nodes = root.querySelectorAll('.cm-reveal:not(.is-ready)');
    var observer = getRevealObserver();

    nodes.forEach(function (node, index) {
      node.classList.add('is-ready');

      if (!observer || reduceMotion) {
        node.classList.add('is-in');
        return;
      }

      // Escalonado dentro de un mismo grupo
      if (!node.style.getPropertyValue('--cm-reveal-delay')) {
        var step = parseInt(node.getAttribute('data-cm-stagger') || '0', 10);
        if (step > 0) node.style.setProperty('--cm-reveal-delay', index * step + 'ms');
      }

      observer.observe(node);
    });
  }

  /* ----------------------------------------------------------------------
     2. Hero — entrada al cargar la imagen
     ---------------------------------------------------------------------- */
  function initHero(root) {
    root.querySelectorAll('.cm-hero:not([data-cm-ready])').forEach(function (hero) {
      hero.setAttribute('data-cm-ready', 'true');

      var img = hero.querySelector('.cm-hero__media img');
      var start = function () {
        requestAnimationFrame(function () {
          hero.classList.add('is-loaded');
        });
      };

      if (!img || img.complete) {
        start();
      } else {
        img.addEventListener('load', start, { once: true });
        img.addEventListener('error', start, { once: true });
      }
    });
  }

  /* ----------------------------------------------------------------------
     3. Ticker — duplica el grupo para que el bucle no tenga costura
     ---------------------------------------------------------------------- */
  function initTicker(root) {
    root.querySelectorAll('.cm-ticker:not([data-cm-ready])').forEach(function (ticker) {
      ticker.setAttribute('data-cm-ready', 'true');

      var track = ticker.querySelector('.cm-ticker__track');
      var group = track && track.querySelector('.cm-ticker__group');
      if (!track || !group) return;

      // Rellena hasta cubrir el ancho de pantalla, luego duplica el conjunto.
      var guard = 0;
      while (group.scrollWidth < ticker.offsetWidth && guard < 20) {
        group.appendChild(group.firstElementChild.cloneNode(true));
        guard++;
      }

      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  /* ----------------------------------------------------------------------
     4. Slider de mundos — transform + swipe táctil, sin librerías
     ---------------------------------------------------------------------- */
  function initWorlds(root) {
    root.querySelectorAll('.cm-worlds:not([data-cm-ready])').forEach(function (section) {
      section.setAttribute('data-cm-ready', 'true');

      var track = section.querySelector('.cm-worlds__track');
      var viewport = section.querySelector('.cm-worlds__viewport');
      if (!track || !viewport) return;

      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var prev = section.querySelector('[data-cm-prev]');
      var next = section.querySelector('[data-cm-next]');
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-cm-dot]'));
      var readout = section.querySelector('[data-cm-now]');
      var bar = section.querySelector('[data-cm-bar]');
      var index = 0;
      var autoTimer = null;

      function perView() {
        var w = window.innerWidth;
        if (w >= 1100) return parseInt(section.dataset.cmPerView || '3', 10);
        if (w >= 750) return 2;
        return 1;
      }

      function maxIndex() {
        return Math.max(0, slides.length - perView());
      }

      function step() {
        var first = slides[0];
        var second = slides[1];
        if (!second) return first.offsetWidth;
        return second.offsetLeft - first.offsetLeft;
      }

      function render() {
        var max = maxIndex();
        track.style.transform = 'translate3d(' + -(index * step()) + 'px, 0, 0)';
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= max;

        // Solo hay tantos dots como posiciones reales, que cambian con el breakpoint
        dots.forEach(function (dot, i) {
          var used = i <= max;
          dot.hidden = !used;
          dot.classList.toggle('is-active', used && i === index);
          dot.setAttribute('aria-current', used && i === index ? 'true' : 'false');
        });

        if (readout) readout.textContent = ('0' + (index + 1)).slice(-2);
        if (bar) {
          var pct = max ? ((index + 1) / (max + 1)) * 100 : 100;
          bar.style.setProperty('--cm-progress', pct.toFixed(1) + '%');
        }
      }

      function goTo(i) {
        var max = maxIndex();
        // Con autoplay el carrusel da la vuelta; a mano se detiene en los extremos
        if (autoTimer && i > max) i = 0;
        index = Math.min(Math.max(i, 0), max);
        render();
      }

      function startAuto() {
        var speed = parseInt(section.dataset.cmAutoplay || '0', 10);
        if (!speed || reduceMotion) return;
        stopAuto();
        autoTimer = window.setInterval(function () {
          goTo(index >= maxIndex() ? 0 : index + 1);
        }, speed * 1000);
      }

      function stopAuto() {
        if (autoTimer) window.clearInterval(autoTimer);
        autoTimer = null;
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); startAuto(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); startAuto(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); startAuto(); });
      });

      section.addEventListener('pointerenter', stopAuto);
      section.addEventListener('pointerleave', startAuto);

      // Swipe / arrastre
      var startX = 0;
      var startOffset = 0;
      var dragging = false;
      var pointerId = null;

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        startOffset = -(index * step());
        track.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!dragging || event.pointerId !== pointerId) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 8) event.preventDefault();
        track.style.transform = 'translate3d(' + (startOffset + delta) + 'px, 0, 0)';
      });

      function endDrag(event) {
        if (!dragging || (event.pointerId != null && event.pointerId !== pointerId)) return;
        dragging = false;
        pointerId = null;
        track.classList.remove('is-dragging');

        var delta = event.clientX - startX;
        var threshold = Math.min(90, step() * 0.2);
        if (delta < -threshold) goTo(index + 1);
        else if (delta > threshold) goTo(index - 1);
        else render();
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Teclado
      section.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { goTo(index + 1); }
        else if (event.key === 'ArrowLeft') { goTo(index - 1); }
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { goTo(index); }, 120);
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto();
        else startAuto();
      });

      render();
      startAuto();
    });
  }

  /* ----------------------------------------------------------------------
     5. Header — transparente sobre el hero, sólido al hacer scroll
     ---------------------------------------------------------------------- */
  function initHeader(root) {
    root.querySelectorAll('.cm-header:not([data-cm-ready])').forEach(function (header) {
      header.setAttribute('data-cm-ready', 'true');

      var hero = document.querySelector('.cm-hero');
      var hideLogo = header.getAttribute('data-hide-logo-on-hero') === 'true';
      // La barra solo se vuelve transparente si está configurada para ello
      var canOverlay = header.classList.contains('cm-header--clear');

      // Barra sólida (por ajuste o por no haber hero): el contenido necesita
      // hueco para no quedar por debajo de ella.
      if (!hero || !canOverlay) {
        document.body.classList.add('cm-header-solid');
      }

      function sync() {
        if (!hero || !canOverlay) return;
        // Overlay mientras el hero siga cubriendo la barra
        var bottom = hero.getBoundingClientRect().bottom;
        var overlay = bottom > header.offsetHeight;
        header.classList.toggle('is-overlay', overlay);
        header.classList.toggle('hide-logo', overlay && hideLogo);
      }

      sync();

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            sync();
            ticking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', sync);

      // Menú móvil
      var burger = header.querySelector('[data-cm-burger]');
      var panel = header.querySelector('.cm-menu');

      if (burger && panel) {
        // Un solo sitio decide si el menú está abierto o cerrado. Antes el
        // cierre por enlace solo quitaba el bloqueo de scroll y dejaba el
        // panel visible y aria-expanded en "true": al volver atrás el menú
        // seguía abierto y el lector de pantalla mentía.
        function setMenu(open) {
          if (open) {
            panel.hidden = false;
            requestAnimationFrame(function () {
              panel.classList.add('is-open');
            });
          } else {
            panel.classList.remove('is-open');
            window.setTimeout(function () {
              if (burger.getAttribute('aria-expanded') === 'false') panel.hidden = true;
            }, 320);
          }

          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
          burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
          // Con el menú abierto, la página de detrás no se mueve
          document.body.classList.toggle('cm-menu-open', open);

          // El foco acompaña al menú: entra al abrirlo y vuelve al botón al
          // cerrarlo. Sin esto, con teclado el foco se quedaba detrás del panel.
          if (open) {
            var first = panel.querySelector('a, button');
            if (first) {
              window.setTimeout(function () {
                if (burger.getAttribute('aria-expanded') === 'true') first.focus();
              }, 340);
            }
          } else if (panel.contains(document.activeElement)) {
            burger.focus();
          }
        }

        burger.addEventListener('click', function () {
          setMenu(burger.getAttribute('aria-expanded') !== 'true');
        });

        // Al pulsar un enlace se cierra del todo: si no, el bloqueo de scroll
        // sobrevive a la navegación con la caché de atrás/adelante
        panel.addEventListener('click', function (event) {
          if (!event.target.closest('a')) return;
          setMenu(false);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
            setMenu(false);
          }
        });

        // Al pasar a escritorio el panel deja de tener sentido: se cierra
        // para que el bloqueo de scroll no se quede pegado.
        window.addEventListener('resize', function () {
          if (window.innerWidth >= 750 && burger.getAttribute('aria-expanded') === 'true') {
            setMenu(false);
          }
        });
      }
    });
  }

  /* ----------------------------------------------------------------------
     Arranque
     ---------------------------------------------------------------------- */
  function boot(root) {
    var scope = root || document;
    initHeader(scope);
    initHero(scope);
    initTicker(scope);
    initWorlds(scope);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // El editor de temas re-renderiza secciones sueltas
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
